import { configureStore } from '@reduxjs/toolkit';
import templateSelectedRootReducer from './TemplateSelectedRootSlice';

const templateSelectedRootStore = configureStore({
  reducer: {
    templateSelectedRoot: templateSelectedRootReducer
  }
});

export default templateSelectedRootStore;